import type { FC } from 'react';

import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
// eslint-disable-next-line no-restricted-imports
import { TopBar as DefaultTopBar } from '@xing-com/top-bar';

type Props = {
  title?: string;
};
export const TopBar: FC<Props> = ({ title = 'XING' }) => {
  const { pageContext } = usePageContext();

  return (
    <DefaultTopBar
      title={title}
      subTitle={pageContext.pageTitle ?? undefined}
      type="subheader"
      skipAdditionalButtons
    />
  );
};
